module.exports = __webpack_public_path__ + "img/yishi24.a31ff832.jpg";